import "./password-change.scss";
import { SHA256 } from "crypto-js";
import { useState, useEffect, FormEvent, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { BsArrowLeft } from "react-icons/bs";
import { BsSave } from "react-icons/bs";

import { IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import Tooltip from "../../../shared/components/tooltip/tooltip";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { postSingleNonTable } from "../../../shared/utils/api";
import { RenderFields } from "../../../shared/utils/render-fields";
import { useBack } from "../../../shared/utils/use-back";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";



const fields: IColumn[] = [
  {
    key: "old_password",
    displayName: "Current password",
    dataType: {
      type: "text",
    },
    subType: "password"
  },
  {
    key: "new_password",
    displayName: "New password",
    dataType: {
      type: "text",
    },
    subType: "password"
  },
  {
    key: "confirm_new_password",
    displayName: "Confirm new password",
    dataType: {
      type: "text",
    },
    subType: "password"
  },
];

const PasswordChange = () => {
  const [validated, setValidated] = useState(false);
  const [toggleWarning, setToggleWarning] = useState(false);

  const [data, setData] = useState({id: "",old_password: "",new_password: "", confirm_new_password: ""});
  const authCtx = useContext(AuthContext);
  const {sendRequest: postSingleRequest, status: allStatusPost, error: errorPost} = useHttp(postSingleNonTable, false, authCtx.token);
  const { handleBack } = useBack();

  useEffect(() => {
    if (allStatusPost === "completed" && !errorPost) {
      handleBack();
    }
  }, [allStatusPost]);

  const handleOnChange = (targetVal: string, inputKey: string) => {
    setData((prevState) => ({ ...prevState, [inputKey]: targetVal }));
  };

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const hashedOldPassword = SHA256(data.old_password).toString();
    const hashedNewPassword = SHA256(data.new_password).toString();

    if (data.new_password !== data.confirm_new_password) {
      setToggleWarning(true);
    }
    if (form.checkValidity() && data.new_password === data.confirm_new_password) {
      setToggleWarning(false);
      authCtx.email && postSingleRequest("change_password", { old_password: hashedOldPassword, new_password: hashedNewPassword});
    }
    setValidated(true);
  };

  const renderFields = () => {
    if (fields.length !== 0) {
      return (
        <RenderFields
          mode="aside"
          fields={fields}
          data={data}
          handleOnChange={handleOnChange}
        />
      );
    }
  };

  return (
    <div className="PasswordChange">
      <div onClick={() => handleBack()} className="listPage-nav-btn">
        <BsArrowLeft />
      </div>
      <div className="PasswordChange-header">
        <h1 className="mt-2 mb-3">
          Change Password
          <Tooltip
            content={"Only you can change your password"}
            direction="top"
            delay={350}
          />
        </h1>
      </div>
      <div className="PasswordChange-form">
        {validateLoadingStatusNew([allStatusPost]) && <Spinner />}
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          {renderFields()}
          {toggleWarning && <div className="PasswordChange-warning">Your confirmation password doesn&apos;t match the new password.</div>}
          <div className="PasswordChange-buttonsGroup">
            <Button disabled={!data.new_password || !data.old_password } className="PasswordChange-save" type="submit" variant="primary">
              <BsSave />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default PasswordChange;
